export default {
  getTyres: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/tyres`),
  saveTyres: (axios, digitalCertificateId, data) =>
    axios.post(`/api/digitalCertificates/${digitalCertificateId}/tyres`, data),
}
